import { render, staticRenderFns } from "./participant.vue?vue&type=template&id=dd995fda&scoped=true&"
import script from "./participant.vue?vue&type=script&lang=js&"
export * from "./participant.vue?vue&type=script&lang=js&"
import style0 from "./participant.vue?vue&type=style&index=0&id=dd995fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd995fda",
  null
  
)

export default component.exports